import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DocumentPayload {
  title: string;
  type: string;
  department: string;
  content: string;
}

@Injectable({ providedIn: 'root' })
export class DocumentService {
  private base = `${environment.apiUrl}/api/documents`;

  constructor(private http: HttpClient) {}

  private headers(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  // GET /api/documents
  getAll(): Observable<any> {
    return this.http.get(this.base, { headers: this.headers() });
  }

  // GET /api/documents/:id
  getOne(id: number): Observable<any> {
    return this.http.get(`${this.base}/${id}`, { headers: this.headers() });
  }

  // POST /api/documents
  create(payload: DocumentPayload): Observable<any> {
    return this.http.post(this.base, payload, { headers: this.headers() });
  }

  // PUT /api/documents/:id
  update(id: number, payload: Partial<DocumentPayload>): Observable<any> {
    return this.http.put(`${this.base}/${id}`, payload, { headers: this.headers() });
  }

  // DELETE /api/documents/:id
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.base}/${id}`, { headers: this.headers() });
  }

  // POST /api/documents/:id/send
  send(id: number, data?: any): Observable<any> {
    return this.http.post(`${this.base}/${id}/send`, data ?? {}, { headers: this.headers() });
  }

  // GET /api/documents/:id/history
  history(id: number): Observable<any> {
    return this.http.get(`${this.base}/${id}/history`, { headers: this.headers() });
  }

  // GET /api/documents/assignments/:id/download
  downloadAssignment(assignmentId: number): Observable<Blob> {
    return this.http.get(`${this.base}/assignments/${assignmentId}/download`, {
      headers: this.headers(),
      responseType: 'blob'
    });
  }

  // POST /api/documents/assignments/:id/send-pdf
  sendAssignmentPdf(assignmentId: number, email?: string): Observable<any> {
    const body = email ? { email } : {};
    return this.http.post(`${this.base}/assignments/${assignmentId}/send-pdf`, body, { headers: this.headers() });
  }
}
